import http from "./http";

export type AdminAuditLogRecord = {
	id: number;
	auditType: string;
	partnerId: number;
	changedByUserId: number | null;
	field: string;
	oldValue: number | null;
	newValue: number | null;
	source: string;
	changedAt: string;
	createdAt: string;
	updatedAt: string;
	/** PartnerBalanceAdjustments row — adjustment delta entered by admin */
	adjustmentAmount?: number | null;
	reason?: string | null;
	balanceBefore?: number | null;
	balanceAfter?: number | null;
	partner?: {
		id: number;
		name?: string | null;
		displayName?: string | null;
	} | null;
	changedByUser?: {
		id: number;
		fullName?: string | null;
		email?: string | null;
	} | null;
};

export type GetAdminAuditLogsParams = {
	page?: number;
	perPage?: number;
	partnerId?: number | null;
	changedByUserId?: number | null;
	field?: string;
	source?: string;
};

export async function getAdminAuditLogs(params: GetAdminAuditLogsParams = {}): Promise<{
	docs: AdminAuditLogRecord[];
	total: number;
	page: number;
	perPage: number;
}> {
	const { data } = await http.get("/admin/audit-logs", { params });
	return {
		docs: (data?.docs || []) as AdminAuditLogRecord[],
		total: data?.total || 0,
		page: data?.page || 1,
		perPage: data?.perPage || params.perPage || 50,
	};
}
